import React from 'react';

import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import UIButton, { EUIButtonVariant } from '@aquariuxfintech/aqx-trader-react-ui/button';
import { ESpacing, ETypography } from '@aquariuxfintech/aqx-trader-react-ui/foundation';
import UIInput, { EUIInputVariant } from '@aquariuxfintech/aqx-trader-react-ui/input';
import UIText from '@aquariuxfintech/aqx-trader-react-ui/text';

import { EDataTestId } from '@aqx-core/common/data-test-id/types';

import AuthResendText from '../../shared/resend-text';
import { useSignUpVerification } from './hooks';

const SignUpCrmVerification: FCC = () => {
  const { t } = useTranslation();
  const {
    isLoading,
    onOtpChange,
    remainingTimeText,
    isResendDisabled,
    onSubmit,
    onClickResend,
    error,
    isButtonDisabled
  } = useSignUpVerification();

  return (
    <StyledContainer>
      <UIText typography={ETypography.DISPLAY_M_BOLD}>{t('Verify Your Email')}</UIText>
      <StyledLabel typography={ETypography.TEXT_XL_REGULAR}>
        {t('Please enter the 6-digits code we sent to your email.')}
      </StyledLabel>

      <UIInput
        variant={EUIInputVariant.BORDERED_PIN}
        onChange={onOtpChange}
        error={error}
        loading={isLoading}
        onEnterKey={onSubmit}
      />
      <AuthResendText
        descriptionText={t("Didn't receive it?")}
        actionText={t('Resend Code')}
        $marginTop={ESpacing.XL}
        onClickResend={onClickResend}
        isResendDisabled={isResendDisabled}
        remainingTimeText={remainingTimeText}
      />

      <StyledButtonContainer>
        <UIButton
          size="large"
          stretch={true}
          loading={isLoading}
          disabled={isButtonDisabled}
          onClick={onSubmit}
          variant={EUIButtonVariant.FILLED_THEMED}
          dataTestId={EDataTestId.SIGN_UP_VERIFICATION_BUTTON}
        >
          {t('Submit')}
        </UIButton>
      </StyledButtonContainer>
    </StyledContainer>
  );
};

export default SignUpCrmVerification;

const StyledContainer = styled.div`
  width: 512px;
`;

const StyledLabel = styled(UIText)`
  margin-top: ${ESpacing.REGULAR}px;
  margin-bottom: ${ESpacing.XXL}px;
  color: ${({ theme }) => theme.themeColors.text.subtle};
`;

const StyledButtonContainer = styled.div`
  margin-top: ${ESpacing.XL}px;
  display: flex;
`;
